/*  TOGGLE
*   A lightweight vanilla js and generic toggle component that works with data
*   data attributes.
*   
*   Trigger:
*   <button data-toggle data-target=".targetClass">Toggle trigger</button>
*
*   Target:
*   <div class="targetClass"></div>
========================================================================== */

const toggleTriggers = Array.from(document.querySelectorAll('[data-toggle]'));

if (toggleTriggers) {
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.getAttribute('data-toggle-target')) return;

      const elm = event.target;
      const selector = elm.getAttribute('data-toggle-target');

      event.preventDefault();
      collapse(selector, 'toggle');
    },
    false
  );

  const fnmap = {
    toggle: 'toggle',
    show: 'add',
    hide: 'remove'
  };

  const collapse = (selector, cmd) => {
    const targets = Array.from(document.querySelectorAll(selector));
    targets.forEach(target => {
      target.classList[fnmap[cmd]]('show');
    });
  };
}
